<template>
    <ChipList
      :item="{items: splited_items}"
      :disable="disable"
      @update="chip_clicked"
    ></ChipList>
  </template>
    
  <script>
    import ChipDateRange from '@/components/explorer/chips/ChipDateRange';
    import ChipDateField from '@/components/explorer/chips/ChipDateField';
  
    
    export default {
      name: 'DateFilterChip',
    
      props: {
        item: {type: Object},
        disable: {
          type: Boolean,
          default: false,
        },
      },
    
      components: {
        ChipList: () => import('@/components/explorer/chips/ChipList'),
        ChipDateRange,
        ChipDateField,
      },
    
      data: () => ({
        date_filter: [{id:'field',component: 'ChipDateField'},{id:'range',component: 'ChipDateRange'}],
      }),
    
      computed: {
        splited_items() {
          return this.date_filter.map(item => ({component: item.component,
                                                readable: item.label,
                                                name: item.id,
                                                value: this.item.value[item.id]}));
        },
      },
    
      methods: {
        chip_clicked(chip_name) {
          let filter_chip_name = chip_name;
          filter_chip_name.path=['filter_dates'];
          this.$emit('update',filter_chip_name);
        },
      },
    }  
  </script>
    